module.exports = __webpack_public_path__ + "img/jumbo.5c325d4.webp";